module.exports = __webpack_public_path__ + "static/img/consult2-3.1e0813d4.png";